import React from 'react';
import Icon from './icon';

function Behance(props) {
  return (
    <Icon {...props}>
      <path id="Behance_6_"  d="M270.9,83.5h-75.2V64.8h75.2L270.9,83.5L270.9,83.5z M145.7,160c4.9,7.5,7.3,16.6,7.3,27.3
		c0,11.1-2.7,21-8.3,29.8c-3.5,5.8-7.9,10.7-13.2,14.7c-5.9,4.6-13,7.7-21.1,9.4c-8.1,1.7-16.9,2.5-26.4,2.5H-0.1V57h90.2
		c22.7,0.4,38.8,7,48.4,19.9c5.7,7.9,8.5,17.4,8.5,28.5c0,11.4-2.9,20.5-8.6,27.5c-3.2,3.9-7.9,7.4-14.2,10.6
		C133.7,147,140.9,152.5,145.7,160z M43,130.6h39.5c8.1,0,14.7-1.5,19.7-4.6c5.1-3.1,7.6-8.6,7.6-16.4c0-8.7-3.3-14.4-10-17.2
		c-5.8-1.9-13.1-2.9-22-2.9H43V130.6z M113.6,184.7c0-9.7-4-16.4-11.9-20c-4.4-2-10.7-3.1-18.7-3.2H43v49.8h39.5
		c8.1,0,14.4-1.1,18.9-3.3C109.5,204,113.6,196.2,113.6,184.7z M298.8,154.3c0.9,6.1,1.3,15,1.2,26.6h-97.4
		c0.5,13.4,5.2,22.8,14,28.2c5.3,3.4,11.7,5,19.3,5c7.9,0,14.4-2,19.4-6.1c2.7-2.2,5.1-5.3,7.2-9.2h35.7c-0.9,7.9-5.2,16-13,24.2
		c-12,13-28.7,19.5-50.3,19.5c-17.8,0-33.5-5.5-47.1-16.5c-13.6-11-20.4-28.8-20.4-53.6c0-23.2,6.1-41,18.4-53.3
		c12.3-12.4,28.2-18.5,47.8-18.5c11.6,0,22.1,2.1,31.4,6.3c9.3,4.2,17,10.8,23.1,19.8C293.6,134.6,297.2,143.9,298.8,154.3z
		 M263.7,157.8c-0.7-9.3-3.8-16.3-9.3-21.1c-5.5-4.8-12.5-7.2-20.7-7.2c-9,0-15.9,2.6-20.9,7.7c-5,5.1-8.1,12-9.3,20.7L263.7,157.8
		L263.7,157.8z"/>
    </Icon>
  )
}

export default Behance;



// WEBPACK FOOTER //
// ./src/icons/components/be.js